import { defineComponent as _defineComponent } from 'vue'
import DetailAccordion from '@/components/DetailAccordion.vue';
import DisplayInput from '@/components/inputs/DisplayInput.vue';
import DisplayDatepicker from '@/components/inputs/DisplayDatepicker.vue';
import FormSection from '@/components/inputs/FormSection.vue';
import { useAbortController } from '@/composables/misc';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { metricsService } from '@/services/metrics.service';
import { currentCustomer } from '@/utils/permissionUtils';
import { isNil } from '@/utils/misc';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { formatDuration } from '@/utils/dates';
import { lengthUnit, weightUnit } from '@/utils/measurement';
import {
  abbreviateNumber,
  formatPercentageOrDefault,
  formatWithUnit,
} from '@/utils/number';
import { useI18n } from '@/composables/i18n';
import BendingProductionPlanBendTimelineGenerator from '@/models/Charts/bendingProductionPlanBendTimelineGenerator';
import { EChartsOption } from 'echarts';
import { BendingPlanDetailData } from '@/views/workcenterConsole/BendIntradayAvailabilityTable/BendingPlanDetailData';
import { getProductivity } from '@/components/bend/productivityUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendingPlanDetailModal',
  props: {
    partGuid: null,
    intervalId: null,
    deviceStringId: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  partGuid: string;
  intervalId: number;
  deviceStringId: string;
};





const data = ref<BendingPlanDetailData | null>(null);
const loading = ref(false);
const chartOption = ref<EChartsOption>();

const { controller } = useAbortController();
const { t } = useI18n();

const chartGenerator = new BendingProductionPlanBendTimelineGenerator(
  WidgetEnum.BendDetailedProductionPlanBendTimeline,
  currentCustomer()!.tenantIdDh,
);

onMounted(async () => {
  await loadProductionPlanData();
  await loadChartData();
});

async function loadProductionPlanData() {
  loading.value = true;
  try {
    data.value = await metricsService.getBendProductionPlanDetail(
      {
        partGuid: props.partGuid,
        intervalId: props.intervalId,
        deviceStringIds: [props.deviceStringId],
        customerIdDh: currentCustomer()!.tenantIdDh,
        timeSpan: FilterTimeSpanEnum.None,
      },
      controller.value,
    );
  } finally {
    loading.value = false;
  }
}

async function loadChartData() {
  const chartData = await chartGenerator.getData(
    [props.deviceStringId],
    [],
    FilterTimeSpanEnum.None,
    undefined,
    {
      partGuid: props.partGuid,
      intervalId: props.intervalId,
    },
  );
  chartOption.value = chartGenerator.updateOptions(chartData!, {
    paramValues: {
      bendsPerPart: data.value!.partDesign.bendsPerPart,
    },
  });
}

function formatWeightWithUserUnitOrNull(value: number | null): string | null {
  if (isNil(value)) {
    return null;
  }
  return formatWithUnit(value, weightUnit());
}

function abbreviateNumberOrNull(value: number | null): string | null {
  if (isNil(value)) {
    return null;
  }
  return abbreviateNumber(value);
}

function formatLengthWithUserUnitOrNull(value: number | null): string | null {
  if (isNil(value)) {
    return null;
  }
  return formatWithUnit(value, lengthUnit());
}

const formattedHandlingSteps = computed<string>(() =>
  data.value?.partDesign.handlingSteps?.toLowerCase().includes('rotate')
    ? data.value.partDesign!.handlingSteps
    : '',
);

onBeforeUnmount(() => {
  chartGenerator.abort();
});

return { __sfc: true,props, emit, data, loading, chartOption, controller, t, chartGenerator, loadProductionPlanData, loadChartData, formatWeightWithUserUnitOrNull, abbreviateNumberOrNull, formatLengthWithUserUnitOrNull, formattedHandlingSteps, DetailAccordion, DisplayInput, DisplayDatepicker, FormSection, isNil, formatDuration, abbreviateNumber, formatPercentageOrDefault, getProductivity }
}

})